import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { 
  AreaChart, 
  Area, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,
  Line
} from 'recharts';

const ScenarioComparisonChart = ({ forecasts, targetName, horizon }) => {
  // Group by scenario
  const scenarioData = forecasts.reduce((acc, f) => {
    if (!acc[f.scenario]) {
      acc[f.scenario] = f;
    }
    return acc;
  }, {});

  const chartData = Object.values(scenarioData).map(f => ({
    scenario: f.scenario,
    mean: f.mean,
    p10: f.p10,
    p90: f.p90,
    probability: f.probability
  }));

  return (
    <Box sx={{ mb: 4 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
            Scenario Comparison
          </Typography>

          <ResponsiveContainer width="100%" height={400}>
            <AreaChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="scenario" />
              <YAxis label={{ value: 'Forecast (%)', angle: -90, position: 'insideLeft' }} />
              <Tooltip 
                formatter={(value) => `${value.toFixed(2)}%`}
                contentStyle={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '8px' }}
                animationDuration={50}
                animationEasing="ease-out"
              />
              <Legend />
              <Area 
                type="monotone" 
                dataKey="p90" 
                stroke="transparent" 
                fill="#e8f4f8" 
                fillOpacity={0.3}
                name="P90 (Upper Bound)"
              />
              <Area 
                type="monotone" 
                dataKey="p10" 
                stroke="transparent" 
                fill="#fff" 
                fillOpacity={1}
                name="P10 (Lower Bound)"
              />
              <Line 
                type="monotone" 
                dataKey="mean" 
                stroke="#2c3e50" 
                strokeWidth={3}
                dot={{ r: 6 }}
                name="Mean Forecast"
              />
            </AreaChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ScenarioComparisonChart;

